
import { Vue, Component, Watch, Prop } from 'vue-property-decorator'
import UserAvatar from '@/views/Project/Observation/components/userAvatar.vue'

import { Debounce } from 'lodash-decorators'
import { getRequest } from '@/plugins/api-axios'
import { getURL } from '@/utils/axios'

import { deserialise } from 'kitsu-core'

@Component({
    components: { UserAvatar },
    inheritAttrs: false,
})
export default class Mentions extends Vue {
    @Prop() resource!: string

    menu = false
    menuInitiated = false
    infiniteId = crypto['randomUUID']()
    searchTerm = ''
    loading = false
    limit = 20
    offset = 0
    users: Array<any> = []

    @Watch('menu')
    initiateSearch() {
        if (this.menu && !this.menuInitiated) {
            this.menuInitiated = true
            this.searchUsers()
            this.infiniteId = crypto['randomUUID']()
        }
    }

    @Watch('searchTerm')
    initLoading() {
        this.loading = true
    }

    @Debounce(500)
    @Watch('searchTerm')
    async initSearch() {
        this.offset = 0
        this.users = []
        this.infiniteId = crypto['randomUUID']()
    }

    async searchUsers($state = null as any) {
        if (!this.menuInitiated) return
        this.loading = true

        let params = {
            'filter[kind]': 'normal',
            'filter[mentionableInResource]': this.resource,
            ...(this.searchTerm &&
                this.searchTerm.length > 1 && {
                    'filter[searchTerm]': this.searchTerm,
                }),
            'page[offset]': this.offset,
            'page[limit]': this.limit,
        }

        const { data } = await getRequest(
            getURL({
                path: `users`,
                base: process.env.VUE_APP_COMMENT_BASE_URL,
                params: {
                    include: '',
                    skipLinks: '',
                },
            }),
            null,
            params
        )

        const newUsers = deserialise(data).data

        this.offset += this.limit

        if ($state) {
            if (newUsers.length == this.limit) {
                $state.loaded()
            } else {
                $state.complete()
            }
        }

        this.users = this.lodash.uniqBy([...this.users, ...newUsers], 'id')

        this.loading = false
    }

    setMentionedUser(user) {
        this.$emit('setMentionedUser', user)
        this.searchTerm = ''
        this.menu = false
    }
}
